import React from "react";
import { motion } from "framer-motion";
import { MdDeleteOutline, MdFormatQuote } from "react-icons/md";
import RatingStars from "../ui/RatingStars";
import StatusBadge from "../ui/StatusBadge";

const TestimonialCard = ({
  item,
  mode = "public",
  isAdminLoggedIn = false,
  onApprove,
  onReject,
  onEdit,
  onDelete,
}) => {
  const isAdmin = mode === "admin";
  const showAdminActions = isAdmin && isAdminLoggedIn;

  return (
    <motion.article
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      whileHover={{ y: -4 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.28 }}
      className="group relative overflow-hidden rounded-2xl border border-white/60 bg-white/70 p-5 shadow-[0_10px_40px_rgba(0,0,0,0.08)] backdrop-blur-xl"
    >
      <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-maroon/10 blur-2xl" />
      <div className="relative z-10">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-3">
            <img
              src={item.photo}
              alt={item.fullName}
              className="h-12 w-12 rounded-full border border-maroon/20 object-cover shadow-sm"
            />
            <div>
              <h3 className="text-base font-semibold text-maroon">{item.fullName}</h3>
              <p className="text-xs text-gray-500">
                {item.company || "Individual Client"}
                {item.city ? ` • ${item.city}` : ""}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {isAdmin ? <StatusBadge status={item.status} /> : null}
            <span className="rounded-full bg-maroon/10 p-2 text-maroon/70">
              <MdFormatQuote className="text-xl" />
            </span>
          </div>
        </div>

        <div className="mt-3">
          <RatingStars value={item.rating} readonly />
        </div>

        <p className="mt-3 text-sm leading-relaxed text-gray-700">{item.message}</p>

        {showAdminActions ? (
          <div className="mt-4">
            <p className="text-xs text-gray-500">{item.email}</p>
            <p className="mt-1 text-xs text-gray-500">
              Submitted: {new Date(item.createdAt).toLocaleDateString()}
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => onApprove && onApprove(item.id)}
                className="rounded-full bg-emerald-100 px-3 py-1.5 text-xs font-semibold text-emerald-700 transition hover:bg-emerald-200"
              >
                Approve
              </button>
              <button
                type="button"
                onClick={() => onEdit && onEdit(item)}
                className="rounded-full bg-sky-100 px-3 py-1.5 text-xs font-semibold text-sky-700 transition hover:bg-sky-200"
              >
                Edit
              </button>
              <button
                type="button"
                onClick={() => onReject && onReject(item.id)}
                className="rounded-full bg-rose-100 px-3 py-1.5 text-xs font-semibold text-rose-700 transition hover:bg-rose-200"
              >
                Reject
              </button>
              <button
                type="button"
                onClick={() => onDelete && onDelete(item.id)}
                className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-3 py-1.5 text-xs font-semibold text-gray-700 transition hover:bg-gray-200"
              >
                <MdDeleteOutline className="text-sm" />
                Delete
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </motion.article>
  );
};

export default TestimonialCard;
